module.exports = __webpack_public_path__ + "static/media/ComponentInstruction.58cd7abe.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/LandingPage/ComponentInstruction.png
// module id = 1048
// module chunks = 2